/* NOTE: THIS FILE IS AUTOGENERATED - DO NOT EDIT IT DIRECTLY */

type SentryConfig =
  | {
      sentryEnabled: false;
    }
  | {
      sentryEnabled: true;
      sentryDSN: string;
      sentryEnvironment: string;
    };

export type Config = {
  gtmId: string;
  shopifyStoreDomain: string;
  shopifyStorefrontToken: string;
  twlBackendApiBaseUrl: string;
  twlReactApiBaseUrl: string;
  gReCaptchaKey: string;
  facebookOauth2ClientId: string;
  googleOauth2ClientId: string;
  googleReviewBadgeMerchantId: string;
  wisePopsSiteId: string;
  wisePopsNotificationsSiteId: string;
  cometlyUid: string;
  msClaritySiteId: string;
  twlShopId: string;
  p2pShopId: string;
} & SentryConfig;


export const config: Config = {"gtmId":"GTM-5CN3TKR","shopifyStoreDomain":"the-whisky-list.myshopify.com","shopifyStorefrontToken":"0f66410306f782a68c3fcd010d292d47","twlBackendApiBaseUrl":"https://backend.thewhiskylist.com.au/api/v1","twlReactApiBaseUrl":"https://thewhiskylist.com.au/react/api/v1","gReCaptchaKey":"6LdeuvIdAAAAACJ2OaDyC5wZAwITRVklfFdwZTpC","facebookOauth2ClientId":"466308797436019","googleOauth2ClientId":"1099458772892-pahb2v19prsbhr1qdjkuakjekqq1ev9d.apps.googleusercontent.com","googleReviewBadgeMerchantId":"132352085","wisePopsSiteId":"nQTS77YHae","wisePopsNotificationsSiteId":"wlGk","cometlyUid":"209261","msClaritySiteId":"pfmnno48t1","twlShopId":"c6ef5fb4-632a-4c04-823e-0f1ddd973e55","p2pShopId":"a36cfe41-a375-4b86-b575-06a35d2a88c9","sentryEnabled":true,"sentryDSN":"https://8dc41124f23c48d48dc137de82a78a28@o292781.ingest.sentry.io/6330194","sentryEnvironment":"production"}